/**
 * Ventilation unique TVA déductible : 4451 immobilisations, 4452 biens et services.
 * Une ligne de classe 2 (compte charge commençant par 2) est une immobilisation.
 */
export function compteTvaDeductible(opts: {
  immobilisation?: boolean;
  compteCharge?: string;
}): '4451' | '4452' {
  if (opts.immobilisation) return '4451';
  const compte = (opts.compteCharge ?? '').trim();
  if (compte.startsWith('2')) return '4451';
  return '4452';
}

export function estImmobilisationCompte(compte: string | undefined): boolean {
  return compteTvaDeductible({ compteCharge: compte }) === '4451';
}
